module.exports = __webpack_public_path__ + "img/fashion_17.856d8f49.jpg";